import * as Diagram from "../../../../components/diagram";

export const ElderlyHealthCaseList = {
  label: "老人健康個案基本資料名冊",
  key: "ElderlyHealthCaseList",
  path: "ElderlyHealth/ElderlyHealthCaseList",
  api: "TCS_V_CaseBasicInformationList",
  render: (options) => (
    <Diagram.ElderlyHealth.ElderlyHealthCaseList {...options} />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  filterColumns: [{ key: "居住地址鄉鎮", label: "鄉鎮", type: "string" }],
  columns: [
    {
      key: "個案編號",
      field: "個案編號",
      header: "案件編號",
    },
    {
      key: "狀態",
      field: "狀態",
      header: "狀態",
    },
    {
      key: "身分證字號",
      field: "身分證字號",
      header: "身分證",
    },
    {
      key: "個案姓名",
      field: "個案姓名",
      header: "個案姓名",
    },
    {
      key: "電話",
      field: "電話",
      header: "電話",
    },
    {
      key: "手機",
      field: "手機",
      header: "手機",
    },
    {
      key: "生日",
      field: "生日",
      header: "生日",
    },
    {
      key: "年齡",
      field: "年齡",
      header: "年齡",
    },
    {
      key: "訪視類別",
      field: "訪視類別",
      header: "訪視類別",
    },
    {
      key: "address_group",
      field: "address_group",
      header: "居住地址",
      child: [
        {
          key: "居住地址鄉鎮",
          field: "居住地址鄉鎮",
          header: "鄉別",
        },
        {
          key: "居住地址村里",
          field: "居住地址村里",
          header: "村別",
        },
        {
          key: "居住地址地址",
          field: "居住地址地址",
          header: "地址",
        },
      ],
    },
    {
      key: "care_group",
      field: "care_group",
      header: "長期照顧個案",
      child: [
        {
          key: "長期照顧個案核定日期",
          field: "長期照顧個案核定日期",
          header: "核定日期",
        },
        {
          key: "長期照顧個案失能等級",
          field: "長期照顧個案失能等級",
          header: "失能等級",
        },
      ],
    },
    {
      key: "聘有外籍看護",
      field: "聘有外籍看護",
      header: "聘有外籍看護",
    },
    {
      key: "live_group",
      field: "live_group",
      header: "居住長照機構",
      child: [
        {
          key: "居住長照機構入住日期",
          field: "居住長照機構入住日期",
          header: "入住日期",
        },
        {
          key: "居住長照機構機構名稱",
          field: "居住長照機構機構名稱",
          header: "機構名稱",
        },
      ],
    },
    {
      key: "居住環境",
      field: "居住環境",
      header: "居住環境",
    },
    {
      key: "死亡日期",
      field: "死亡日期",
      header: "死亡日期",
    },
  ],
};
